import { Student, Submission } from "../types";
import firebase from "firebase";
import { useEffect, useState } from "react";

const useStudent = (uid: string = "") => {
  const [studentProfile, setStudentProfile] = useState<Student>();
  const [submissions, setSubmissions] = useState<Submission[]>();
  useEffect(() => {
    if (uid) {
      firebase
        .firestore()
        .collection("students")
        .where("uid", "==", uid)
        .get()
        .then((result) => {
          if (result.empty) {
            // This is probably an admin
            return;
          }
          const nextProfile = {
            ...result.docs[0].data(),
            id: result.docs[0].id,
          } as Student;
          setStudentProfile(nextProfile);

          firebase
            .firestore()
            .collection("submissions")
            .where("userId", "==", nextProfile.id)
            .get()
            .then((result) => {
              if (result.empty) {
                return;
              }
              const subs: Submission[] = [];
              result.forEach((doc) => {
                subs.push({
                  ...(doc.data() as Submission),
                  id: doc.id,
                } as Submission);
              });
              setSubmissions(subs);
            });
        });
    }
  }, [uid]);

  return { studentProfile, submissions };
};

export default useStudent;
